export const GAME_WIDTH = 640;
export const GAME_HEIGHT = 480;
export const GAME_GRAVITY = 0.8;
export const GAME_MAX_TICKS = 10000;
export const POPULATION_SIZE = 100;
export const IMMIGRATION_EPOCH = 10;